import {Component, OnInit} from '@angular/core';
import {fuseAnimations} from '../../../../../core/animations';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {CheckModalComponent} from '../../../check-save-modal/check-modal';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {SpaceService} from '../../../../../core/services/space.service';
import {PlatformsService} from '../../../../../core/services/platforms.service';

@Component({
    selector: 'new-space',
    templateUrl: './new-space.component.html',
    styleUrls: ['./new-space.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class NewSpaceComponent implements OnInit {
  name = '';
  spaceBoard: any = [{spbId: 1}];
  returnBack;
  platforms = [];
  platformId;
  constructor(public toastr: ToastrService, public spaceService: SpaceService, public router: Router,
              public dialog: MatDialog, public snackBar: MatSnackBar, public translate: TranslateService,
              public platformsService: PlatformsService) {

  }

  ngOnInit() {
    this.getPlatforms();
  }

  getPlatforms() {
    this.platformsService.getPlatforms().subscribe((res: any) => {
      if (res) {
        this.platforms = res;
      }
    });
  }

  removeSpaceBoard(spbId) {
    let index = this.spaceBoard.findIndex(el => +el.spbId === +spbId);
    if (index !== -1) {
      this.spaceBoard.splice(index, 1);
      if (!this.spaceBoard.length) {
        this.spaceBoard.push({spbId: 1});
      }
    }
  }

  addSpaceBoard() {
    let lastId = this.spaceBoard[this.spaceBoard.length - 1].spbId;
    this.spaceBoard.push({spbId: + lastId + 1});
    setTimeout(() => {
      let input: any = document.getElementById(+ lastId + 1 + '_subcat');
      if (input) {
        input.focus();
      }
    }, 100);
  }

  addSpace() {
    if (!this.platformId) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('choose_platform');
      this.toastr.error(msg, title);
      return;
    }
    let emptySubError = true;
    for (let i = 0; i < this.spaceBoard.length; i++) {
      let input: any = document.getElementById(this.spaceBoard[i].spbId + '_subcat');
      let value = '';
      if (input && input.value) {
        value = input.value;
        emptySubError = false;
      }
      this.spaceBoard[i].name = value;
    }
    if (emptySubError) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('add_board_error');
      this.toastr.error(msg, title);
      return;
    }
    if (!this.name) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('enter_space_name');
      this.toastr.error(msg, title);
      return;
    }
    let space = {
      name: this.name,
      platformId: this.platformId
    };
    return this.spaceService.addSpace(space).toPromise().then((res: any) => {
      if (res && res.id) {
        for (let i = 0; i < this.spaceBoard.length; i++) {
          if (this.spaceBoard[i].name) {
            this.spaceService.addSpaceBoard({name: this.spaceBoard[i].name, spaceId: res.id}).subscribe();
          }
        }
        let title = this.translate.instant('successfully');
        let msg = this.translate.instant('space_created');
        this.toastr.success(msg, title);
        this.returnBack = true;
        this.router.navigate([ './pages/settings/spaces' ]);
        return true;
      }
    });
  }

  canDeactivate (): Observable<boolean> | boolean {
    if (this.returnBack) {
      return true;
    } else {
      return this.goBack();
    }
  }

  goBack (): any {
    let dialogRef;
    let input: any = document.getElementById(this.spaceBoard[0].spbId + '_subcat');
    if (this.name || (input && input.value)) {
      dialogRef = this.dialog.open(CheckModalComponent , {
        panelClass: 'unsave-form-dialog',
        width: '400px',
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          let emptySubError = true;
          for (let i = 0; i < this.spaceBoard.length; i++) {
            let _input: any = document.getElementById(this.spaceBoard[i].spbId + '_subcat');
            if (_input && _input.value) {
              emptySubError = false;
            }
          }
          if (this.name && !emptySubError) {
            return this.addSpace();
          } else {
            let msg = this.translate.instant('fill_req_field');
            this.snackBar.open(msg , '' , {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }
}
